import SitePageLayout from '../components/SitePageLayout';

export default function TermsOfServiceScreen() {
  return (
    <SitePageLayout title="Terms of Service" effectiveDate="February 11, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Pratikay (the "App"), a product of
        Xerratus, LLC ("Company," "we," "us," or "our"). By using the App, you agree to these
        Terms.
      </p>

      <section className="legal-section">
        <h2>1. Service Overview</h2>
        <p>
          Pratikay is a language speaking practice app that supports partner conversations,
          custom personas, translation, phonetics, and audio playback.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Eligibility</h2>
        <p>You must be legally permitted to use the App in your jurisdiction.</p>
      </section>

      <section className="legal-section">
        <h2>3. Accounts and Security</h2>
        <p>
          You are responsible for your account activity and for maintaining the confidentiality
          of your credentials.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Partner Features</h2>
        <ul>
          <li>Users may send partner requests.</li>
          <li>Recipients may accept or reject requests.</li>
          <li>Partners may unlink conversations/partner relationships.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>5. Acceptable Use</h2>
        <p>
          You agree not to misuse the service, violate laws, or infringe the rights of others.
        </p>
      </section>

      <section className="legal-section">
        <h2>6. Subscriptions and Credit Packs</h2>
        <p>Pratikay offers:</p>
        <ul>
          <li>Auto-renewable subscriptions</li>
          <li>One-time top-off credit packs</li>
        </ul>
        <p>
          Billing, renewals, cancellation, and refunds are handled by Apple App Store and Google
          Play under their terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>7. No Advertising</h2>
        <p>Pratikay does not serve third-party advertisements.</p>
      </section>

      <section className="legal-section">
        <h2>8. Intellectual Property</h2>
        <p>
          The App, software, and branding are owned by Xerratus, LLC and its licensors and are
          protected by law.
        </p>
      </section>

      <section className="legal-section">
        <h2>9. Disclaimer</h2>
        <p>The App is provided "as is" and "as available" without warranties of any kind.</p>
      </section>

      <section className="legal-section">
        <h2>10. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Pratikay is not liable for indirect,
          incidental, or consequential damages arising from use of the App.
        </p>
      </section>

      <section className="legal-section">
        <h2>11. Termination</h2>
        <p>
          You may stop using the App at any time. We may suspend or terminate access for
          violations of these Terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>12. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use after changes means you
          accept the updated Terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>13. Contact</h2>
        <p>For legal/support questions: support@xerratus.com</p>
      </section>
    </SitePageLayout>
  );
}
